import { catchError, filter, switchMap } from 'rxjs/operators';
import { concat, EMPTY, from, of } from 'rxjs';
import axios from 'axios-observable';
import { PayloadEpic } from '@/store/epics/epic-types';
import { actions, asyncActions } from '@/store/slices';
import { apiEndpoints } from '@/store/constants';
import { DeliverySiteModel } from '@/models';
import { objectToUrlSearchParams } from '@/utils/url-search-params-utils';
import { FetchAllDeliverySitesPayload } from "@/store/slices/staff/delivery-sites.slice";

export const fetchAllDeliverySitesEpic: PayloadEpic<FetchAllDeliverySitesPayload, DeliverySiteModel[]> = (action$) => {
    return action$.pipe(
        filter(asyncActions.deliverySites.fetchAll.match),
        switchMap(({ payload }) => concat(
            of(actions.deliverySites.setIsLoading(true)),
            fetchDeliverySites(payload).pipe(
                switchMap(({ data }) => from([
                    actions.deliverySites.setAll(data.results),
                    actions.deliverySites.setTotalCount(data.count),
                ])),
                catchError((error) => {
                    console.error('fetchAllDeliverySitesEpic', error);

                    return EMPTY;
                }),
            ),
            of(actions.deliverySites.setIsLoading(false)),
        )),
    );
};

const fetchDeliverySites = (payload: FetchAllDeliverySitesPayload) => {
    const searchParams = objectToUrlSearchParams(payload);

    return axios.get<ListResponse<DeliverySiteModel>>(`${apiEndpoints.deliverySites()}?${searchParams}`);
};
